<template>
  <div class="mb-4">
    <h5 class="mb-2">
      <h5 class="mb-2">{{ "canceled" | setText("Отменено") }}</h5>
    </h5>
    {{ currentRequest }}
  
    <cancel :model_type="`subscription`" :model_id="id" @update="update" />
  </div>
</template>
<script>
import cancel from "@/components/Cancel.vue";
export default {
  components: { cancel },
  methods: {},
  data: () => ({}),
  props: ["id", "currentRequest"],
  methods: {
    update() {
      this.$emit("update", true);
    },
    cancel() {
      //{
      //   "polis_sery": "E-COS",
      //   "polis_number": "0000009"
      //   "annulment_date": "ДД.ММ.ГГГГ"
      //}
    },
  },
};
</script>

 